import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
export function MobileMenuSection() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const isActive = (url: string) => location.pathname === url;
  const navLinks = [{
    title: 'Home',
    url: '/'
  }, {
    title: 'ForceX Complete',
    url: '/products/forcex-complete'
  }, {
    title: 'ForceX DIY',
    url: '/products/forcex-diy'
  }, {
    title: 'About',
    url: '/about'
  }, {
    title: 'Warranty',
    url: '/warranty'
  }, {
    title: 'Contact',
    url: '/contact'
  }];
  return <>
      <div className="md:hidden flex items-center" data-id="element-425">
        <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-brand-dark hover:text-brand-yellow focus:outline-none p-2" data-id="element-426">
          {isMenuOpen ? <X className="h-8 w-8" data-id="element-427" /> : <Menu className="h-8 w-8" data-id="element-428" />}
        </button>
      </div>

      {isMenuOpen && <div className="md:hidden bg-white border-t border-gray-100 absolute left-0 right-0 top-full shadow-lg" data-id="element-429">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-430">
            {navLinks.map(link => <Link key={link.url} to={link.url} className={`block px-3 py-4 rounded-md text-base font-bold uppercase ${isActive(link.url) ? 'bg-brand-light text-brand-yellow' : 'text-brand-dark hover:bg-gray-50 hover:text-brand-yellow'}`} onClick={() => setIsMenuOpen(false)} data-id="element-431">
                {link.title}
              </Link>)}
          </div>
        </div>}
    </>;
}